import React, { useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import HeaderInner from "../../Components/HeaderInner";
import Carosle from "../../Components/Carosle";
import { ShowSPA } from "../../API/SPAAPI";
import { useBusinessNameContext } from "./../../context/BusinessName";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import SpaServicesList from "../../Components/SpaServicesList";
import BookingCarosle from "../../Components/BookingCarosle";
import SpaFallbackImg from "../../assets/new_imgs/SPA1.jpg";
import { trackCategoryViewed, trackMenuItemViewed } from "../../utils/mixpanel";

function Spa() {
  const { businessName } = useBusinessNameContext();

  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const spa_uuid = params.spa_uuid;
  const lang = localStorage.getItem("lang");

  let spa;
  let images;
  let bgColor;
  let color;
  let text;
  let spaId;
  let spaServices;
  let spaCategories;
  const { data, isLoading, error } = ShowSPA(room_uuid, spa_uuid, lang);

  if (!isLoading) {
    if (error) {
      if (error?.response.status == 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data.data.status === false) {
        navigate(`/${room_uuid}/qr-scan`);
      } else {
        spa = data.data.data.spa;
        images = spa?.header_images;
        color = data.data.data.color;
        bgColor = data.data.data.header_color;
        text = data.data.data.header_title;
        spaServices = spa.services;
        spaCategories = spa.categories;
        spaId = spa.id;
      }
    }
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    if (!isLoading && !error && spa) {
      trackMenuItemViewed({
        item_id: spaId,
        item_name: text || "",
        category_name: "Spa & Wellness",
      });
    }
  }, [isLoading]);

  const hasCategories = spaCategories?.length > 0;

  return (
    <>
      <HeaderInner bgColor={bgColor} color={color} headerName={text} />
      <main
        className={
          hasCategories
            ? "bg-white pad-top-0 pb-30 restaurant-booking"
            : "home-main bg-white back-white pad-top-0 pb-30"
        }
      >
        {isLoading ? (
          <CustomBusinessServiceLoader
            businessName={businessName}
            loader={"spa"}
          />
        ) : (
          <>
            {/* Spas without categories keep listing their services directly. */}
            {!hasCategories ? (
              <>
                <Carosle className={"dot-bar"} headerImages={images} />
                <SpaServicesList
                  services={spaServices}
                  room_uuid={room_uuid}
                  spa_uuid={spa_uuid}
                />
              </>
            ) : (
              <>
                {images?.length > 0 && (
                  <header className="img-header m-0">
                    <Carosle className={"dot-bar"} headerImages={images} />
                  </header>
                )}
                {/* One full-width card per category, laid out like the
                    restaurant booking list. */}
                <div className="container p-2">
                  {spaCategories?.map((category, idx) => {
                    const image =
                      category.image ||
                      category.services?.[0]?.image ||
                      SpaFallbackImg;
                    return (
                      <div
                        className="r_b_h booking-card restaurant-option"
                        key={idx}
                      >
                        <Link
                          to={`/${room_uuid}/spa/${spa_uuid}/category/${category.id}`}
                          onClick={() => {
                            trackCategoryViewed({
                              category_id: category.id,
                              category_name: category.name,
                              category_type: "spa",
                            });
                          }}
                        >
                          <div className="bc-img">
                            <BookingCarosle
                              noAuto={true}
                              images={[{ image }]}
                            />
                          </div>
                          <div className="bc-text">
                            <p className="bct-1">{category.name}</p>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </>
        )}
      </main>
    </>
  );
}
export default Spa;
